import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { formatCurrency } from "@/partner/features/products";
import { useAnalyticsSalesByProviderQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsSalesByProviderTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsSalesByProviderQuery({
    variables: { filter: filter as never },
  });

  const rows = (data?.analyticsSales.salesByProvider ?? []).map((row) => [
    row.provider,
    formatNumber(row.sales),
    formatCurrency(row.revenue, data?.analyticsSales.currency ?? "USD"),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.sales.tableByProvider")}
      columns={[
        { name: t("analytics.sales.columnProvider") },
        { name: t("analytics.sales.columnSales") },
        { name: t("analytics.sales.columnRevenue") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.SalesByProviderType}
          filter={filter}
        />
      }
    />
  );
};
